<template>
  <div
    class="refonte-side-menu-collapse"
    v-bind:class="`${props.class}`">
    <div
      class="collapse-header"
      v-on:click="() => toggleIsOpen()">
      <div class="collapse-header-content">
        <div class="collapse-header-title">
          <refonte-pastille
            v-bind:status="
              props.title_pastille
                ? props.title_pastille
                : props.title.toLowerCase()
            " />
          <span
            v-if="!props.is_reduced"
            class="collapse-header-title-text">
            {{ props.title }}
          </span>
        </div>
      </div>
      <div
        class="collapse-header-chevron"
        v-if="
          hasSlotContent(slots.default) &&
          props.show_dropdown &&
          !props.is_reduced
        ">
        <IconChevronDown v-if="!isOpen" />
        <IconChevronUp v-else />
      </div>
    </div>
    <div
      v-if="isOpen && props.show_dropdown"
      class="collapse-content">
      <refonte-separator />
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
  import IconChevronDown from '@/assets/img/refonte/icons/display/icon-chevron-down.svg?component';
  import IconChevronUp from '@/assets/img/refonte/icons/display/icon-chevron-up.svg?component';
  import { ref, useSlots, Fragment } from 'vue';
  import type { Slot, VNode } from 'vue';
  import RefontePastille from '@/components/refonte/pastille/refonte-pastille.vue';
  import RefonteSeparator from '@/components/refonte/separators/refonte-separator.vue';

  const props = withDefaults(
    defineProps<{
      title_pastille?: string;
      title: string;
      class?: string;
      content_class?: string;
      no_content?: boolean;
      show_dropdown?: boolean;
      is_reduced?: boolean;
    }>(),
    {
      class: '',
      content_class: ''
    }
  );

  const isOpen = ref<boolean>(true);

  function toggleIsOpen() {
    isOpen.value = !isOpen.value;
  }

  const slots = useSlots();

  const isVnodeEmpty = (vnode: Array<VNode>): boolean => {
    return vnode.every(
      (node: VNode) =>
        node.type === Comment ||
        (node.type === Text &&
          typeof node.children === 'string' &&
          !node.children.trim()) ||
        (node.type === Fragment && isVnodeEmpty(node.children as Array<VNode>))
    );
  };

  const hasSlotContent = (slot: Slot<any> | undefined) => {
    if (!slot) {
      return false;
    }
    return !isVnodeEmpty(slot());
  };
</script>

<style lang="scss" scoped>
  .refonte-side-menu-collapse {
    @apply bg-refonte-white;
    border-radius: 8px;

    .collapse-header {
      @apply flex cursor-pointer items-center justify-between;
      padding-top: 4px;
      padding-bottom: 4px;
      padding-left: 8px;
      padding-right: 8px;
      .collapse-header-content {
        @apply flex flex-wrap items-center;

        .collapse-header-title {
          @apply flex items-center;
          padding-top: 6px;
          padding-bottom: 6px;
          padding-left: 10px;
          padding-right: 4px;
          gap: 8px;
          span {
            @apply text-refonte-black;
            font-weight: 600;
            line-height: 18px;

            &.collapse-header-title-text {
              font-size: 14px;
              line-height: 18px;
            }
          }
        }
      }
      .collapse-header-chevron {
        @apply flex shrink-0 items-center justify-center;
        width: 32px;

        :deep(svg) {
          @apply text-refonte-black;
          width: 20px;
          height: 20px;
        }
      }
    }
    .collapse-content {
      padding: 0 8px 8px;
    }
  }
</style>
